import { getSpacing, createStyleFunction } from 'utils/ui';
import { fillParent } from 'styles/mixins';
export var positionPropsDef = [{
  styleProp: 'position',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'pos',
  properties: ['position'],
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'top',
  getValue: getSpacing
}, {
  styleProp: 'left',
  getValue: getSpacing
}, {
  styleProp: 'bottom',
  getValue: getSpacing
}, {
  styleProp: 'right',
  getValue: getSpacing
}, {
  styleProp: 'fillParent',
  getRules: function getRules(value) {
    return value ? fillParent : undefined;
  }
}, {
  styleProp: 'float',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'z',
  properties: ['zIndex'],
  getValue: function getValue(z, theme) {
    var _theme$globals$z$z;
    return (_theme$globals$z$z = theme.globals.z[z]) !== null && _theme$globals$z$z !== void 0 ? _theme$globals$z$z : z;
  }
}];
export default createStyleFunction(positionPropsDef);